import { useEffect } from 'react';
import { useParams } from 'react-router';

import { PageLayout } from '~components/page/PageLayout';
import IconLibrary from '~extension/icon-library';
import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import { selectAddonsIconLibraryConfig, selectAddonsIsIconLibraryEnabled } from '~store/selectors';

export default function IconLibraryPage() {
  const { hlIconLibrary } = useLabels(['hlIconLibrary']);
  const navigateToDefault = useNavigateToDefault();

  // read store values
  const isEnabled = useAppSelector(selectAddonsIsIconLibraryEnabled);
  const config = useAppSelector(selectAddonsIconLibraryConfig);

  // derived values
  const { realm } = useParams();

  useEffect(() => {
    if (!isEnabled) {
      navigateToDefault();
    }
  }, [isEnabled, navigateToDefault]);

  return (
    <PageLayout title={hlIconLibrary} className="page--icon-library">
      <div className="c-view__header u-margin-vertical-md u-padding-horizontal-xxl">
        <div className="o-grid o-grid--unpad o-grid--bottom">
          <div className="o-grid__cell o-grid__cell--width-10">
            <h2>{hlIconLibrary}</h2>
          </div>
        </div>
      </div>
      <div className="c-view__content relative flex-grow overflow-hidden">
        <div className="h-full">
          <IconLibrary {...config} realm={realm} />
        </div>
      </div>
    </PageLayout>
  );
}
